var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"google",class:_vm.currentLocale === 'ur' ? 'text-right' : '',attrs:{"type":"button","name":"button"},on:{"click":_vm.loginToGoogle}},[_c('icon',{attrs:{"name":'google'}}),_vm._v("google")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }